import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect, useMemo } from "react";
import IBF from "..";
import FormRow from "components/form/FormRow";
import { useForm } from "react-final-form";

export default function IBFEditFields({ visita, TipoClass }) {
    console.log("visita ", visita);
    const [tipo, setTipo] = useTipoApontamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const params = useMemo(() => visita.cliente.getParams(IBF, "Mecanizado", TipoClass), [visita.cliente]);

    const [apontamento] = useFieldValue();
    const form = useForm();

    useEffect(() => {
        if (tipo !== "Mecanizado") {
            setTipo("Mecanizado");
        }
    }, [setTipo, tipo]);

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = IBF.calcConformidade(apontamento, params);
            form.change("conformidade", IBF.calcConformidade(apontamento, params));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} showVariedade showCorte />

            <ApontamentoAmostraParams tipoFixedValue="Mecanizado" />

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="entrenos" label="Entrenós" />
                <TextInput type="number" name="base" label="Base" />
                <TextInput type="number" name="meio" label="Meio" />
                <TextInput type="number" name="ponta" label="Ponta" />
                <TextInput type="number" name="brocados" label="Brocados" disabled />
            </ApontamentoColetas>

            <ApontamentoResultado conformidadeLabel="Infestação (%)">
                <FormRow>
                    <TextInput name="totalCanas" label="Total Canas" disabled />
                </FormRow>
                <FormRow>
                    <TextInput name="totalEntrenos" label="Total Entrenós" disabled />
                </FormRow>
                <FormRow>
                    <TextInput name="totalBrocados" label="Total Entrenós Brocados" disabled />
                </FormRow>
            </ApontamentoResultado>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
